import { defineMessages } from 'react-intl'

export const auEvergreenPageTitles = defineMessages({
  shop: {
    id: '_vcJZeJHEe1qf9obbVuo',
    defaultMessage: 'Luxury Escapes Shop - Luxury Escapes AU',
  },
  'lux-plus': {
    id: 'B_YlRa2zVWhfPdLuJzyn',
    defaultMessage: 'LuxPlus+ Membership - Luxury Escapes AU',
  },
  'affiliate-program': {
    id: 'EqnInJ_DM57MIK45a986',
    defaultMessage: 'Affiliate Program - Luxury Escapes AU',
  },
  support: {
    id: 'nbhl3OUN33SgJok22AFe',
    defaultMessage: 'Help & Support - Luxury Escapes AU',
  },
  weddings: {
    id: '233vGJLPW8uvuMDiMGM6',
    defaultMessage: 'Luxury Weddings - Luxury Escapes AU',
  },
  flights: {
    id: 'MZXQlp8wos5TFz55dg2e',
    defaultMessage: 'Luxury Escapes Flights - Luxury Escapes AU',
  },
  societe: {
    id: 'ONhaNp9Xw-7OpTsclcQ-',
    defaultMessage: 'Luxury Escapes Membership | Société',
  },
  experiences: {
    id: '4IxDAJ_GiY1hOkfsto1d',
    defaultMessage: 'Luxury Experiences - Luxury Escapes AU',
  },
  'car-hire': {
    id: 'LPq5NBzWh_ZaWaGMyX0d',
    defaultMessage: 'Car Hire - Luxury Escapes AU',
  },
})

export const auEvergreenPageHeadings = defineMessages({
  shop: {
    id: 'Jw-0EF8gAx4DdGx6pCMm',
    defaultMessage: 'Shop',
  },
  'lux-plus': {
    id: 'PuEsS21JZA5c47HEpp4q',
    defaultMessage: 'LuxPlus+',
  },
  'affiliate-program': {
    id: 'vFH78-ojzTtrQekjpHIV',
    defaultMessage: 'Affiliate program',
  },
  support: {
    id: 'TClfQnowY0JCcqXuVT_l',
    defaultMessage: 'Help & Support',
  },
  weddings: {
    id: '7Iyc9m9qC3Lmxum8CR-j',
    defaultMessage: 'Weddings',
  },
  flights: {
    id: 'ByQAy_9lga2C8rDwT--c',
    defaultMessage: 'Flights',
  },
  societe: {
    id: 'Vf7HqpyIdR1HmTV0u2nm',
    defaultMessage: 'Société',
  },
  experiences: {
    id: 'NQYZ7_QfTBV_I8Oo9X4U',
    defaultMessage: 'Experiences',
  },
  'car-hire': {
    id: 'XG1oe5NogsPZQaT9SDk_',
    defaultMessage: 'Car hire',
  },
})
